module.exports = __webpack_public_path__ + "img/fatu.425f1a2d.png";